export type StandardApiError = {
  code: string;
  message: string;
  status: number;
  details?: unknown;
  traceId?: string;
};

export const isApiError = (value: unknown): value is StandardApiError => {
  return (
    value !== null &&
    typeof value === 'object' &&
    'code' in value &&
    typeof (value as StandardApiError).code === 'string' &&
    'message' in value &&
    typeof (value as StandardApiError).message === 'string' &&
    'status' in value &&
    typeof (value as StandardApiError).status === 'number'
  );
};
